<!-- Shared Elegant Loader -->
<app-elegant-loader *ngIf="isLoadingBiddingConfig" [id]="'bidding-config-loader'" [loadingText]="'Loading Bidding Type Configuration'"></app-elegant-loader>

<!-- Main Content (Hidden while loading) -->
<ng-container *ngIf="!isLoadingBiddingConfig">
  <!-- ─── Day Ahead ──────────────────────────────────────────────────────────── -->
  <section class="config-card">
    <div class="config-card__left">
      <h3 class="config-title">Day Ahead Configuration</h3>
    </div>
    <div class="config-card__right">
      <div>
        <button class="view-config" [disabled]="!enabledStatus['dayAhead']" (click)="openDialog('dayAhead')">
          View Configuration
          <div class="forward-btn">→</div>
        </button>
      </div>
      <label class="toggle">
        <input type="checkbox" [checked]="enabledStatus['dayAhead']"
          (change)="$event.stopPropagation(); onToggleChange('dayAhead', $event)" />
        <span class="toggle__slider"></span>
      </label>
    </div>
  </section>

  <!-- ─── Monthly ──────────────────────────────────────────────────────────────── -->
  <section class="config-card">
    <div class="config-card__left">
      <h3 class="config-title">Monthly Configuration</h3>
    </div>
    <div class="config-card__right">
      <div>
        <button class="view-config" [disabled]="!enabledStatus['monthly']" (click)="openDialog('monthly')">
          View Configuration
          <div class="forward-btn">→</div>
        </button>
      </div>
      <label class="toggle">
        <input type="checkbox" [checked]="enabledStatus['monthly']"
          (change)="$event.stopPropagation(); onToggleChange('monthly', $event)" />
        <span class="toggle__slider"></span>
      </label>
    </div>
  </section>

  <!-- ─── Preferential ────────────────────────────────────────────────────────── -->
  <section class="config-card">
    <div class="config-card__left">
      <h3 class="config-title">Preferential Exchange of Bids</h3>
    </div>
    <div class="config-card__right">
      <div>
        <button class="view-config" [disabled]="!enabledStatus['preferential']" (click)="openDialog('preferential')">
          View Configuration
          <div class="forward-btn">→</div>
        </button>
      </div>
      <label class="toggle">
        <input type="checkbox" [checked]="enabledStatus['preferential']"
          (change)="$event.stopPropagation(); onToggleChange('preferential', $event)" />
        <span class="toggle__slider"></span>
      </label>
    </div>
  </section>
</ng-container>


<!-- ─── Configuration Dialog ─────────────────────────────────────────────────── -->
<div class="modal-overlay" *ngIf="showDialog">
  <div class="modal-content">
    <!-- Close Button -->
    <button type="button" class="close-modal-btn" (click)="discardChanges()">&times;</button>

    <h2>
      Configure the
      <span *ngIf="selectedBidType === 'dayAhead'">Day Ahead</span>
      <span *ngIf="selectedBidType === 'monthly'">Monthly</span>
      <span *ngIf="selectedBidType === 'preferential'">Preferential Exchange</span>
      Bidding Type
    </h2>

    <div class="config-grid-layout"
      style="display: grid; grid-template-columns: 1fr 1fr; gap: 32px; margin-bottom: 1.5rem;">

      <!-- Left column -->
      <div class="grid-column column-left" style="display: flex; flex-direction: column; gap: 1.5rem;">

        <!-- Matching Algorithm (Day Ahead & Monthly only) -->
        <div class="form-group" *ngIf="selectedBidType !== 'preferential'" style="margin-bottom: 0; min-width: auto;">
          <label for="matchingAlgorithm">Matching Algorithm</label>
          <select id="matchingAlgorithm" [(ngModel)]="currentConfig.matchingAlgorithm">
            <option *ngFor="let algo of matchingAlgorithms" [value]="algo.id">{{ algo.name }}</option>
          </select>
          <p class="price-note">Select an appropriate matching algorithm to decide the strike price.</p>
        </div>

        <div class="form-group preferential-field" *ngIf="selectedBidType === 'preferential'"
          style="margin-bottom: 0; min-width: auto;">
          <label for="fix_price_commercial">Fix Price (Commercial)</label>
          <input type="number" id="fix_price_commercial" [(ngModel)]="currentConfig.fix_price_commercial" placeholder="10"
            style="width: 100px; padding: 0.4rem; border-radius: 4px; border: 1px solid rgba(255,255,255,0.6); background-color: #557377; color: #ffffff; font-size: 16px; margin-bottom: 4px;" />
          <p class="price-note">Fixed Price for Commercial user</p>
        </div>

        <!-- Preferential: Max Range -->
        <div class="form-group preferential-field" *ngIf="selectedBidType === 'preferential'"
          style="margin-bottom: 0; min-width: auto;">
          <label for="maxRangeDays">Maximum Range (in Days)</label>
          <input type="number" id="maxRangeDays" [(ngModel)]="currentConfig.maxRangeDays" placeholder="10"
            style="width: 100px; padding: 0.4rem; border-radius: 4px; border: 1px solid rgba(255,255,255,0.6); background-color: #557377; color: #ffffff; font-size: 16px; margin-bottom: 4px;" />
          <p class="price-note">The range between the start and the end date will be less than maximum range.</p>
        </div>

        <!-- Preferential: Days Ahead -->
        <div class="form-group preferential-field" *ngIf="selectedBidType === 'preferential'"
          style="margin-bottom: 0; min-width: auto;">
          <label for="daysAhead">Days Ahead (in Days)</label>
          <input type="number" id="daysAhead" [(ngModel)]="currentConfig.daysAhead" placeholder="2"
            style="width: 100px; padding: 0.4rem; border-radius: 4px; border: 1px solid rgba(255,255,255,0.6); background-color: #557377; color: #ffffff; font-size: 16px; margin-bottom: 4px;" />
          <p class="price-note">The user cannot choose an end date less than the days ahead from the start date.</p>
        </div>

      </div>

      <!-- Right column -->
      <div class="grid-column column-right" style="display: flex; flex-direction: column; gap: 1.5rem;">

        <div class="form-group preferential-field" *ngIf="selectedBidType === 'preferential'"
          style="margin-bottom: 0; min-width: auto;">
          <label for="fix_price_residential">Fix Price (Residential)</label>
          <input type="number" id="fix_price_residential" [(ngModel)]="currentConfig.fix_price_residential" placeholder="10"
            style="width: 100px; padding: 0.4rem; border-radius: 4px; border: 1px solid rgba(255,255,255,0.6); background-color: #557377; color: #ffffff; font-size: 16px; margin-bottom: 4px;" />
          <p class="price-note">Fixed price for Residential User</p>
        </div>

        <!-- Closing Time -->
        <div class="form-group" style="margin-bottom: 0; min-width: auto;">
          <label for="hoursBeforeClosing">Closing Time:</label>
          <input type="number" id="hoursBeforeClosing" [(ngModel)]="currentConfig.hoursBeforeClosing" placeholder="8"
            style="width: 100px; padding: 0.4rem; border-radius: 4px; border: 1px solid rgba(255,255,255,0.6); background-color: #557377; color: #ffffff; font-size: 16px; margin-bottom: 4px;" />
          <p class="price-note">
            Close the Bid Rounds [input] hours before the
            <span *ngIf="selectedBidType === 'monthly'">Month</span>
            <span *ngIf="selectedBidType === 'dayAhead'">Day</span>
            <span *ngIf="selectedBidType === 'preferential'">Bid</span>
            Ends
          </p>
        </div>

        <div class="form-group preferential-field" *ngIf="selectedBidType === 'preferential'"
          style="margin-bottom: 0; min-width: auto;">
        
          <label for="preferentialBidMode">
            Preferential Bid Mode
          </label>
        
          <select id="preferentialBidMode" [(ngModel)]="currentConfig.preferential_bid_mode" style="
              width: 140px;
              padding: 0.4rem;
              border-radius: 4px;
              border: 1px solid rgba(255,255,255,0.6);
              background-color: #557377;
              color: #ffffff;
              font-size: 16px;
              margin-bottom: 4px;
            ">
            <option value="custom">Custom</option>
            <option value="fixed">Fixed</option>
          </select>
        
          <p class="price-note">
            Select whether preferential bids use custom or fixed mode.
          </p>
        
        </div>
      </div>
    </div>

    <!-- Price Type Radio Buttons -->
    <div class="radio-group">
      <div class="dynamic-group">
        <label>
          <input type="radio" name="priceType" value="dynamic" [(ngModel)]="currentConfig.priceType" />
          Dynamic Price
        </label>
        <div class="dynamic-price" [class.disabled-section]="currentConfig.priceType !== 'dynamic'">
          <h3>Enter Dynamic Price Range</h3>
          <div class="form-inline">
            <label for="minPrice">Min Price (in Rs)</label>
            <input type="number" id="minPrice" [(ngModel)]="currentConfig.minPrice"
              [disabled]="currentConfig.priceType !== 'dynamic'" placeholder="5" />
          </div>
          <div class="form-inline">
            <label for="maxPrice">Max Price (in Rs)</label>
            <input type="number" id="maxPrice" [(ngModel)]="currentConfig.maxPrice"
              [disabled]="currentConfig.priceType !== 'dynamic'" placeholder="2500" />
          </div>
          <p class="price-note">The user can enter a dynamic price while placing bids.</p>
        </div>
      </div>
      <div class="vertical-divider"></div>
      <div class="fixed-group">
        <label>
          <input type="radio" name="priceType" value="fixed" [(ngModel)]="currentConfig.priceType" />
          Fixed Price
        </label>
        <div class="fixed-price" [class.disabled-section]="currentConfig.priceType !== 'fixed'">
          <h3>Enter a Fixed Price</h3>
          <div class="form-inline">
            <label for="fixedPrice">Enter Rate (in Rs)</label>
            <input type="number" id="fixedPrice" [(ngModel)]="currentConfig.fixedPrice"
              [disabled]="currentConfig.priceType !== 'fixed'" placeholder="24" />
          </div>
          <p class="price-note">The users will trade using this standard price.</p>
        </div>
      </div>
    </div>

    <!-- Dialog Buttons -->
    <div class="dialog-buttons">
      <button class="btn--primary" [disabled]="isSavingBiddingConfig" (click)="saveConfiguration()">
        {{ isSavingBiddingConfig ? 'Saving...' : 'Save Configuration' }}
      </button>
      <button class="btn--secondary" [disabled]="isSavingBiddingConfig" (click)="discardChanges()">Discard Changes</button>
    </div>
  </div>
</div>